import { useEffect } from "react";

const ZoomControl = (props) => {
  
  useEffect(() => {
    if (props.map.zoomControl) {
      props.map.removeControl(props.map.zoomControl);
    }
  }, [props.map]);

  return (
    <>
      <button className="ccl-button ccl-button--default ccl-button--default-neg map-button" onClick={() => props.map.zoomIn()} aria-label="Zoom in">
        <i className="fa-solid fa-plus"></i>
      </button>
      <button className="ccl-button ccl-button--default ccl-button--default-neg map-button" onClick={() => props.map.zoomOut()} aria-label="Zoom out">
        <i className="fa-solid fa-minus"></i>
      </button>
    </>
  );
}

export default ZoomControl;
